var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNtbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#EEC315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6819 4.60406C10.6819 4.55349 10.6721 4.5034 10.6527 4.45665C10.6334 4.40991 10.6051 4.36743 10.5694 4.33164C10.5336 4.29585 10.4912 4.26746 10.4445 4.24809C10.3978 4.22872 10.3477 4.21875 10.2971 4.21875H7.38675L7.39125 4.22438H4.58269C4.22606 4.22438 3.9375 4.5135 3.9375 4.87012V13.1299C3.9375 13.4865 4.22606 13.7756 4.58269 13.7756H5.62612C5.98275 13.7756 6.27131 13.4865 6.27131 13.1299V7.09763C6.27131 6.52612 6.95869 6.23644 7.36706 6.63581L9.603 8.82169C9.97369 9.18394 10.5733 8.97919 10.6819 8.51231C10.6931 8.46394 10.6988 8.41331 10.6988 8.35988L10.6819 4.60406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4803 4.22437H12.3103C11.9897 4.22437 11.7287 4.48536 11.7287 4.80711V11.052C11.7287 11.5678 11.1083 11.8294 10.7398 11.4682L8.29013 9.07368C7.92113 8.71368 7.30125 8.97468 7.30125 9.49049V10.8202C7.30125 10.8405 7.30238 10.8607 7.30406 10.881L7.30125 10.8782V13.2542C7.30125 13.5456 7.53694 13.7812 7.82775 13.7812H11.0565L11.0486 13.7756H13.4803C13.8021 13.7756 14.0625 13.5146 14.0625 13.1929V4.80711C14.0625 4.48536 13.8021 4.22437 13.4803 4.22437Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtbc);
export default __webpack_public_path__ + "static/media/ntbc.416bef285bb8e162f13fce7b7d06e31a.svg";
export { ForwardRef as ReactComponent };